import { translations } from './translations';

export class LanguageManager {
  constructor() {
    // Default language is English
    this.currentLanguage = 'en';
    this.listeners = [];
  }

  /**
   * Get current language
   */
  getCurrentLanguage() {
    return this.currentLanguage;
  }

  /**
   * Set language and notify all listeners
   */
  setLanguage(languageCode) {
    if (!translations[languageCode]) {
      console.warn(`Language ${languageCode} not supported`);
      return false;
    }

    this.currentLanguage = languageCode;
    
    // Notify all listeners
    this.notifyListeners();
    
    return true;
  }

  /**
   * Get text for current language
   */
  getText(key) {
    const keys = key.split('.');
    let value = translations[this.currentLanguage];
    
    for (const k of keys) {
      if (value && value[k] !== undefined) {
        value = value[k];
      } else {
        console.warn(`Translation key "${key}" not found for language "${this.currentLanguage}"`);
        // Fallback to English
        value = this.getFallbackText(key);
        break;
      }
    }
    
    return value || key;
  }

  /**
   * Get fallback text in English
   */
  getFallbackText(key) {
    const keys = key.split('.');
    let value = translations['en'];
    
    for (const k of keys) {
      if (value && value[k] !== undefined) {
        value = value[k];
      } else {
        return key;
      }
    }
    
    return value || key;
  }

  /**
   * Add a listener to be notified when language changes
   */
  addListener(listener) {
    if (typeof listener === 'function') {
      this.listeners.push(listener);
    }
  }

  /**
   * Remove a listener
   */
  removeListener(listener) {
    const index = this.listeners.indexOf(listener);
    if (index > -1) {
      this.listeners.splice(index, 1);
    }
  }

  /**
   * Notify all listeners of language change
   */
  notifyListeners() {
    this.listeners.forEach(listener => {
      try {
        listener(this.currentLanguage);
      } catch (error) {
        console.error('Error in language change listener:', error);
      }
    });
  }

  /**
   * Get available languages
   */
  getAvailableLanguages() {
    return Object.keys(translations).map(code => ({
      code,
      name: this.getLanguageName(code)
    }));
  }

  /**
   * Get language name in its native language
   */
  getLanguageName(code) {
    const names = {
      'en': 'English',
      'fr': 'Français',
      'it': 'Italiano'
    };
    return names[code] || code;
  }

  /**
   * Check if a language is supported
   */
  isLanguageSupported(code) {
    return translations.hasOwnProperty(code);
  }
}

// Create a singleton instance
export const languageManager = new LanguageManager(); 